import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import {
  CollapsibleText,
  SearchBreadcrumbs,
  useDeviceContext
} from '@spotahome/ui-library';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import './CountryInformation.scss';

const CountryInformation = ({ countryName, countryId }) => {
  const { deviceType } = useDeviceContext();

  return (
    <LandingSection className="country-information">
      <SearchBreadcrumbs countryId={countryId} />
      <h2 className="country-information__title">
        {trans('countries.information.title', {
          country: countryName
        })}
      </h2>
      <CollapsibleText
        showMoreText={trans('common.view-more')}
        showLessText={trans('common.view-less')}
        collapsedClassName="country-information__collapsed"
        showIcon={false}
        showButton={deviceType !== 'desktop'}
        isCollapsed={deviceType !== 'desktop'}
        collapsibleHeight={4}
      >
        <div className="country-information__content">
          <div
            className="country-information__column"
            dangerouslySetInnerHTML={{
              __html: trans(`seo.countries.${countryId}.description`)
            }}
          />
        </div>
      </CollapsibleText>
    </LandingSection>
  );
};

CountryInformation.propTypes = {
  countryName: PropTypes.string.isRequired,
  countryDescription: PropTypes.arrayOf(PropTypes.string).isRequired,
  countryId: PropTypes.string.isRequired
};

export default CountryInformation;
